import { main, nav, shell, secondaryNav } from "./AppShell.module.css";
import type { FC, PropsWithChildren } from "react";
import { Navbar } from "./Navbar";
import cx from "clsx";
import { SecondaryNavbar } from "./SecondaryNavbar";
import type { NavMenuOptions } from "../../types/menu";

interface AppShellProps extends PropsWithChildren {
  menu: NavMenuOptions;
  classNames?: {
    root?: string;
    main?: string;
  };
}

interface SectionProps extends PropsWithChildren {
  className: string;
}

const Nav: FC<SectionProps> = ({ className, children }) => {
  return (
    <nav className={className} aria-label="primary navigation">
      {children}
    </nav>
  );
};

const SecondaryNav: FC<SectionProps> = ({ className, children }) => {
  return (
    <nav className={className} aria-label="secondary navigation">
      {children}
    </nav>
  );
};

const Main: FC<SectionProps> = ({ className, children }) => {
  return (
    <main className={className}>
      {children}
    </main>
  );
};

const Shell: FC<SectionProps> = ({ className, children }) => {
  return (
    <div className={className}>
      {children}
    </div>
  );
};

export const AppShell: FC<AppShellProps> = ({ children, menu, classNames }) => {
  const rootClasses = cx(shell, classNames?.root);
  const mainClasses = cx(main, classNames?.main);

  return (
    <Shell className={rootClasses}>
      <Nav className={nav}>
        <Navbar menu={menu} />
      </Nav>

      <SecondaryNav className={secondaryNav}>
        <SecondaryNavbar menu={menu} />
      </SecondaryNav>

      <Main className={mainClasses}>
        {children}
      </Main>
    </Shell>
  );
};
